// ─────────────────────────────────────────────────────────────────────────────
// theme/mxp-tracker.js — Senzorul de pe site
//
// Rulează în browserul vizitatorului, pe fiecare pagină, dar numai pentru conturile lăsate de
// poarta de colectare din mxp-preload. Urmărește ce face pe site (produs văzut, căutare, coș,
// favorite…), pune totul într-o coadă și trimite loturi semnate (HMAC) către server
// (POST /v1/events). Ține identitatea anonimă în cookie-ul `mxp_aid`, sesiunea în
// sessionStorage și respectă consimțământul din Shopify (refuz = nu trimite nimic).
// Bannerele noastre nu trec pe aici: le cere scriptul secțiunii, mxp-homepage.js. Afișările și clicurile
// bannerelor site-ului de același fel (`data-mxp-product-type`) se măsoară aici, pe paginile din
// `mxp_pagini_bannere`.
// ─────────────────────────────────────────────────────────────────────────────

// Cheia cu care se semnează evenimentele — aceeași valoare ca `THEME_SIGNING` de pe Heroku.
window.MXP_CONFIG = window.MXP_CONFIG || {};
if (!window.MXP_CONFIG.themeSigning) {
  window.MXP_CONFIG.themeSigning = '0a0b7b9d0a4cfe5ef3f2753d093d49c6412054537cb9a3b0301284bd2f06f866';
}

(function () {
  'use strict';

  var CFG = window.MXP_CONFIG || {};
  var themeSigning = CFG.themeSigning;
  if (!CFG.endpoint || !themeSigning) {
    // Fără config nu trimitem nimic și nu stricăm pagina, dar o spunem: lipsa adresei înseamnă că
    // `mxp-preload` nu e în `theme.liquid`.
    if (window.console && console.warn) {
      console.warn(
        CFG.endpoint
          ? '[mxp] missing MXP_CONFIG.themeSigning — events are not sent'
          : '[mxp] missing MXP_CONFIG.endpoint — is mxp-preload rendered in theme.liquid?',
      );
    }
    return;
  }

  // Poarta de colectare, hotărâtă la Shopify în mxp-preload: cine nu e pe listă nu primește nici
  // cookie, nici evenimente, nici raportare de consimțământ.
  if (CFG.colectare !== true) return;

  var BATCH_MAX = 50;
  var FLUSH_DELAY_MS = 1500;
  var RETRY_DELAY_MS = 5000;
  var ANON_COOKIE = 'mxp_aid';
  var CONSENT_COOKIE = 'mxp_consent';
  var ANON_TTL_DAYS = 365;
  var ANON_PATTERN = /^a_[a-z0-9]{12,}$/;
  var CONSENT_VALUES = { on: 1, off: 1, withdrawn: 1, unknown: 1 };

  // Tipurile de produs pentru care se trimit evenimente de pe pagina produsului. Restul catalogului
  // nu se urmărește: fără ele n-am avea ce personaliza, iar cererile ar pleca degeaba.
  var TIPURI_URMARITE = {
    Canapea: 1,
    Pat: 1,
    Saltea: 1,
    Fotoliu: 1,
    Covor: 1,
    Scaun: 1,
    'Masă': 1,
    Dulap: 1,
    'Comodă': 1,
    'Set canapea - masă exterior': 1,
  };

  // --- Cookie-uri ---------------------------------------------------------------

  // Citește un cookie după nume.
  function readCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(prefix) === 0) {
        return decodeURIComponent(parts[i].slice(prefix.length));
      }
    }
    return null;
  }

  // Scrie un cookie valabil `days` zile, pe tot site-ul.
  function writeCookie(name, value, days) {
    var maxAge = Math.floor(days * 24 * 60 * 60);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; Max-Age=' +
      maxAge +
      '; Path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }

  // --- Identitate ---------------------------------------------------------------

  // Șir aleatoriu de lungimea cerută.
  function randomId(len) {
    var bytes = new Uint8Array(len);
    crypto.getRandomValues(bytes);
    var out = '';
    for (var i = 0; i < bytes.length; i++) out += (bytes[i] % 36).toString(36);
    return out;
  }

  // anon_id din cookie; dacă lipsește sau e invalid, creăm unul nou pe 365 de zile.
  function getOrCreateAnonId() {
    var existing = readCookie(ANON_COOKIE);
    if (existing && ANON_PATTERN.test(existing)) return existing;
    var fresh = 'a_' + randomId(16);
    writeCookie(ANON_COOKIE, fresh, ANON_TTL_DAYS);
    return fresh;
  }

  // session_id, valabil doar în vizita curentă.
  var memorySessionId = null;
  function getSessionId() {
    try {
      var v = sessionStorage.getItem('mxp_session_id');
      if (!v) {
        v = 's_' + randomId(16);
        sessionStorage.setItem('mxp_session_id', v);
      }
      return v;
    } catch (e) {
      if (!memorySessionId) memorySessionId = 's_' + randomId(16);
      return memorySessionId;
    }
  }

  var anonId = getOrCreateAnonId();
  var sessionId = getSessionId();

  // --- Consimțământ (API-ul Shopify Customer Privacy) ---------------------------

  // Traduce răspunsul Shopify în starea noastră: on / off / null (nedecis).
  function mapShopifyConsent(c) {
    if (!c) return null;
    var a = c.analytics !== undefined ? c.analytics : c.analyticsAllowed;
    if (a === 'yes' || a === true) return 'on';
    if (a === 'no' || a === false) return 'off';
    return null;
  }

  // Consimțământul curent din API-ul Shopify, dacă e disponibil.
  function readShopifyConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.currentVisitorConsent === 'function') return cp.currentVisitorConsent();
    } catch (e) {
      /* API indisponibil */
    }
    return null;
  }

  // Salvează starea în cookie (doar dacă e decisă).
  function persistConsent(c) {
    var state = mapShopifyConsent(c);
    if (state) writeCookie(CONSENT_COOKIE, state, ANON_TTL_DAYS);
  }

  // Starea curentă: API → cookie → unknown.
  function getConsentState() {
    var fromApi = mapShopifyConsent(readShopifyConsent());
    if (fromApi) return fromApi;
    var raw = readCookie(CONSENT_COOKIE);
    return raw && CONSENT_VALUES[raw] ? raw : 'unknown';
  }

  // Adresa endpoint-ului de consimțământ, derivată din cea de evenimente.
  function consentEndpoint() {
    return String(CFG.endpoint || '').replace(/\/v1\/events\/?$/, '/v1/consent');
  }

  // Raportează serverului o schimbare de consimțământ (semnată, ca evenimentele).
  function reportConsentChange(from, to) {
    try {
      var url = consentEndpoint();
      if (!url || !themeSigning) return;
      var body = JSON.stringify({ anon_id: anonId, from: from, to: to, source: 'cookie_banner' });
      var timestamp = String(Date.now());
      sign(themeSigning, timestamp + '.' + body)
        .then(function (signature) {
          fetch(url, {
            method: 'POST',
            keepalive: true,
            headers: Object.assign(
              {
                'content-type': 'application/json',
                'x-mxp-timestamp': timestamp,
                'x-mxp-signature': signature,
              },
              CFG.extraHeaders || {},
            ),
            body: body,
          }).catch(function () {});
        })
        .catch(function () {});
    } catch (e) {
      /* tracking-ul nu strică niciodată pagina */
    }
  }

  // Aplică starea curentă, ascultă schimbările și cere API-ul dacă nu e încă încărcat.
  function initConsent() {
    persistConsent(readShopifyConsent());
    document.addEventListener('visitorConsentCollected', function (e) {
      var before = readCookie(CONSENT_COOKIE) || 'unknown';
      persistConsent(e && e.detail ? e.detail : readShopifyConsent());
      var after = readCookie(CONSENT_COOKIE) || 'unknown';
      if (after !== before) reportConsentChange(before, after);
    });
    try {
      var s = window.Shopify;
      if (s && !s.customerPrivacy && typeof s.loadFeatures === 'function') {
        s.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err) persistConsent(readShopifyConsent());
        });
      }
    } catch (e) {
      /* rămânem pe cookie / unknown */
    }
  }
  initConsent();

  // --- Semnătură și coadă -------------------------------------------------------

  // Semnătura HMAC-SHA256 (hex) a mesajului; serverul verifică `timestamp.body`.
  function sign(secret, message) {
    var enc = new TextEncoder();
    return crypto.subtle
      .importKey('raw', enc.encode(secret), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign'])
      .then(function (key) {
        return crypto.subtle.sign('HMAC', key, enc.encode(message));
      })
      .then(function (buf) {
        var bytes = new Uint8Array(buf);
        var hex = '';
        for (var i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, '0');
        return hex;
      });
  }

  // Cheie unică per eveniment.
  function uuidv4() {
    return crypto.randomUUID ? crypto.randomUUID() : 'id-' + randomId(24);
  }

  var queue = [];
  var completions = [];
  var flushTimer = null;

  // Cheia rândului care descrie vizita pe pagina asta (product_view / collection_view / search).
  // Pe ea se scriu, la plecare, timpul petrecut și derularea.
  var cheiaVizitei = null;

  // Pune un eveniment în coadă (cu plicul: identitate, sesiune, pagină) și programează trimiterea.
  function enqueue(eventType, eventData, idempotencyKey) {
    var key = idempotencyKey || uuidv4();
    var entry = {
      idempotency_key: key,
      event_version: 1,
      source: 'theme',
      anon_id: anonId,
      session_id: sessionId,
      client_ts: new Date().toISOString(),
      event_type: eventType,
      event_data: eventData,
    };
    if (PAGE_TYPE) entry.page_type = PAGE_TYPE;
    var url = location.href;
    if (url && url.length <= 2048) entry.page_url = url;
    var ref = document.referrer;
    if (ref && /^https?:\/\//i.test(ref) && ref.length <= 2048) entry.referrer = ref;

    queue.push(entry);
    if (queue.length >= BATCH_MAX) {
      flush();
    } else {
      scheduleFlush();
    }
    return key;
  }

  // Pune în coadă cifrele măsurate la plecare, pentru rândul vizitei. Fără nicio cifră nu se trimite.
  function enqueueCompletion(key, masuri) {
    var entry = { idempotency_key: key };
    var areCeva = false;
    if (typeof masuri.dwell_ms === 'number') {
      entry.dwell_ms = masuri.dwell_ms;
      areCeva = true;
    }
    if (typeof masuri.scroll_pct === 'number') {
      entry.scroll_pct = masuri.scroll_pct;
      areCeva = true;
    }
    if (areCeva) completions.push(entry);
  }

  // Trimiterea amânată cu 1,5 s, ca să adune un lot.
  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = setTimeout(function () {
      flushTimer = null;
      flush();
    }, FLUSH_DELAY_MS);
  }

  // Trimite un lot semnat; la eroare de rețea sau răspuns 5xx îl mai încearcă o dată, după 5 s, cu
  // semnătură nouă, iar la 4xx nu.
  function send(batch, batchCompletions, isRetry) {
    var consent = getConsentState();
    if (consent === 'off' || consent === 'withdrawn') return Promise.resolve();

    var body = JSON.stringify({ events: batch, completions: batchCompletions });
    var timestamp = String(Date.now());

    return sign(themeSigning, timestamp + '.' + body)
      .then(function (signature) {
        return fetch(CFG.endpoint, {
          method: 'POST',
          keepalive: true,
          headers: Object.assign(
            {
              'content-type': 'application/json',
              'x-mxp-consent': consent,
              'x-mxp-timestamp': timestamp,
              'x-mxp-signature': signature,
            },
            CFG.extraHeaders || {},
          ),
          body: body,
        });
      })
      .then(function (res) {
        if (res && res.status >= 500) throw new Error('server ' + res.status);
      })
      .catch(function () {
        if (isRetry) return;
        setTimeout(function () {
          send(batch, batchCompletions, true);
        }, RETRY_DELAY_MS);
      });
  }

  // Trimite lotul din coadă.
  function flush() {
    if (flushTimer) {
      clearTimeout(flushTimer);
      flushTimer = null;
    }
    if (queue.length === 0 && completions.length === 0) return;

    var consent = getConsentState();
    if (consent === 'off' || consent === 'withdrawn') {
      queue.length = 0;
      completions.length = 0;
      return;
    }

    return send(queue.splice(0, BATCH_MAX), completions.splice(0, BATCH_MAX), false);
  }

  // La părăsirea paginii trimitem ce a mai rămas.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);

  window.MXP = {
    track: enqueue,
    flush: flush,
    anonId: anonId,
    sessionId: sessionId,
    consent: getConsentState,
  };

  // --- Contextul paginii ----------------------------------------------------------

  // Pune o cheie text doar dacă are valoare reală (serverul respinge șirurile goale).
  function putStr(obj, key, val) {
    if (val !== undefined && val !== null && String(val).trim() !== '') {
      obj[key] = String(val);
    }
  }

  // Metadatele Shopify ale paginii, dacă există.
  function shopifyMeta() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) || null;
  }

  // Tipul paginii: din metadatele Shopify, altfel din URL.
  function detectPageType() {
    var meta = shopifyMeta();
    var pt = (meta && meta.page && meta.page.pageType) || (window.__st && window.__st.p) || null;
    if (pt === 'product') return 'pdp';
    if (pt === 'collection') return 'plp';
    if (pt === 'search') return 'search';
    if (pt === 'home' || pt === 'index') return 'homepage';
    var path = location.pathname;
    if (/\/products\/[^/?#]+/.test(path)) return 'pdp';
    if (/\/collections\/[^/?#]+\/?$/.test(path)) return 'plp';
    if (/\/search\b/.test(path)) return 'search';
    return pt ? 'other' : null;
  }

  // Bucata din URL care se potrivește cu expresia dată.
  function pathSlug(re) {
    var m = location.pathname.match(re);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Contextul paginii dedus singur (produs, colecție), când tema nu-l dă prin MXP_PAGE.
  function autodetectPage() {
    var pageType = detectPageType();
    if (!pageType) return null;
    var page = { page_type: pageType };
    var meta = shopifyMeta();

    if (pageType === 'pdp') {
      var pid = meta && meta.product && meta.product.id != null ? String(meta.product.id) : null;
      var handle = pathSlug(/\/products\/([^/?#]+)/);
      if (!pid || !handle) return page;
      var product = { id: pid, handle: handle };
      if (meta.product.type) product.type = String(meta.product.type);
      var qv = new URLSearchParams(location.search).get('variant');
      var formId = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var variant =
        qv ||
        (formId && formId.value) ||
        (meta.product.variants && meta.product.variants[0] && meta.product.variants[0].id);
      if (variant) product.variant_id = String(variant);
      page.product = product;
    } else if (pageType === 'plp') {
      var chandle = pathSlug(/\/collections\/([^/?#]+)/);
      if (chandle) page.collection = { handle: chandle };
    }
    return page;
  }

  var PAGE = window.MXP_PAGE || autodetectPage();

  // Tipul paginii pentru „plicul" evenimentului, din lista acceptată de server.
  var ENVELOPE_PAGE_TYPES = { homepage: 1, pdp: 1, plp: 1, search: 1, cart: 1, checkout: 1, account: 1, other: 1 };
  function envelopePageType() {
    var pt = PAGE && PAGE.page_type ? String(PAGE.page_type) : null;
    if (pt === 'collection') pt = 'plp';
    if (pt && ENVELOPE_PAGE_TYPES[pt]) return pt;
    var path = location.pathname;
    if (/^\/cart/.test(path)) return 'cart';
    if (/^\/checkout/.test(path)) return 'checkout';
    if (/^\/account/.test(path)) return 'account';
    if (path === '/' || path === '') return 'homepage';
    return null;
  }
  var PAGE_TYPE = envelopePageType();

  // Produsul paginii intră în urmărire doar dacă tipul lui e în listă. Tipul necitit înseamnă „nu
  // trimitem": altfel ar pleca evenimente pentru produse din afara listei, fără să știm.
  var avertizatFaraTip = false;
  function produsulPaginiiEUrmarit() {
    var p = PAGE && PAGE.product;
    if (!p) return false;
    if (!p.type) {
      if (!avertizatFaraTip && window.console && console.warn) {
        avertizatFaraTip = true;
        console.warn('[mxp] tipul produsului nu se poate citi — nu se trimit evenimente pentru el');
      }
      return false;
    }
    return TIPURI_URMARITE[String(p.type)] === 1;
  }

  // Același produs cu cel al paginii? Evenimentele altor produse (recomandări, liste) nu se filtrează,
  // fiindcă acolo nu le știm tipul.
  function esteProdusulPaginii(productId) {
    var p = PAGE && PAGE.product;
    return p != null && p.id != null && String(p.id) === String(productId);
  }

  // Poarta folosită la fiecare eveniment legat de un produs.
  function seTrimitePentru(productId) {
    if (PAGE_TYPE !== 'pdp' || !esteProdusulPaginii(productId)) return true;
    return produsulPaginiiEUrmarit();
  }

  // ╔══ EVENIMENT: product_view ═══════════════════════════════════════════════╗
  // Produs văzut, la încărcarea paginii de produs.
  function captureProductView(page) {
    if (!page || page.page_type !== 'pdp' || !page.product) return;
    var p = page.product;
    if (p.id === undefined || p.id === null || p.handle === undefined) return;
    if (!seTrimitePentru(p.id)) return;
    var data = { product_id: String(p.id), product_handle: String(p.handle) };
    putStr(data, 'category', p.category);
    putStr(data, 'room', p.room);
    putStr(data, 'price_tier', p.price_tier);
    putStr(data, 'variant_id', p.variant_id);
    putStr(data, 'from_collection', p.from_collection);
    var price = Number(p.price);
    if (isFinite(price) && price >= 0) data.price = price;
    cheiaVizitei = enqueue('product_view', data);
  }
  captureProductView(PAGE);
  // ╚══ sfârșit product_view ══════════════════════════════════════════════════╝

  // ╔══ EVENIMENT: collection_view ════════════════════════════════════════════╗
  // Colecție văzută, la încărcare și la fiecare schimbare de filtre.

  // Parametrii din URL care NU sunt filtre (paginare, sortare, tracking).
  var FILTER_IGNORE_EXACT = {
    page: 1, sort_by: 1, q: 1, query: 1, view: 1, grid_list: 1, layout: 1,
    fbclid: 1, gclid: 1, gad_source: 1, msclkid: 1, dclid: 1, ttclid: 1, twclid: 1,
    ref: 1, srsltid: 1, _ga: 1, _gl: 1,
  };

  // Filtrele active, citite din URL.
  function filtersFromUrl() {
    var params = new URLSearchParams(location.search);
    var out = {};
    var keys = [];
    params.forEach(function (_v, k) {
      if (FILTER_IGNORE_EXACT[k]) return;
      if (k.indexOf('utm_') === 0 || k.indexOf('mc_') === 0) return;
      if (/_(and|or)_condition$/.test(k)) return;
      if (keys.indexOf(k) === -1) keys.push(k);
    });
    for (var i = 0; i < keys.length; i++) {
      var vals = params.getAll(keys[i]);
      out[keys[i]] = vals.length > 1 ? vals : vals[0];
    }
    return out;
  }

  // Filtrele colecției: din temă dacă le dă explicit, altfel din URL.
  function collectionFilters(c) {
    if (
      c &&
      c.filters_active &&
      typeof c.filters_active === 'object' &&
      !Array.isArray(c.filters_active) &&
      Object.keys(c.filters_active).length
    ) {
      return c.filters_active;
    }
    return filtersFromUrl();
  }

  // Emite evenimentul pentru colecția dată.
  function emitCollectionView(c) {
    var data = { collection_handle: String(c.handle) };
    putStr(data, 'category', c.category);
    if (c.products_count_displayed != null) {
      var n = Number(c.products_count_displayed);
      if (isFinite(n) && n >= 0) data.products_count_displayed = Math.floor(n);
    }
    var f = collectionFilters(c);
    if (Object.keys(f).length) data.filters_active = f;
    cheiaVizitei = enqueue('collection_view', data);
  }

  // La încărcarea unei pagini de colecție.
  function captureCollectionView(page) {
    if (!page || (page.page_type !== 'plp' && page.page_type !== 'collection')) return;
    var c = page.collection;
    if (!c || c.handle === undefined || c.handle === null || String(c.handle).trim() === '') return;
    emitCollectionView(c);
  }
  captureCollectionView(PAGE);

  // Re-emite când filtrele se schimbă fără reîncărcare (pushState / popstate), cu pauză de 800 ms.
  function setupCollectionFilterWatch(page) {
    if (!page || (page.page_type !== 'plp' && page.page_type !== 'collection')) return;
    var c = page.collection;
    if (!c || !c.handle) return;
    var lastKey = JSON.stringify(filtersFromUrl());
    var timer = null;

    function onUrlChange() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        var key = JSON.stringify(filtersFromUrl());
        if (key === lastKey) return;
        lastKey = key;
        emitCollectionView(c);
      }, 800);
    }

    var methods = ['pushState', 'replaceState'];
    for (var i = 0; i < methods.length; i++) {
      (function (m) {
        var orig = history[m];
        if (typeof orig === 'function') {
          history[m] = function () {
            var r = orig.apply(this, arguments);
            onUrlChange();
            return r;
          };
        }
      })(methods[i]);
    }
    window.addEventListener('popstate', onUrlChange);
  }
  setupCollectionFilterWatch(PAGE);
  // ╚══ sfârșit collection_view ═══════════════════════════════════════════════╝

  // ╔══ EVENIMENT: search ═════════════════════════════════════════════════════╗
  // Căutare, la încărcarea paginii de rezultate (se emite și la 0 rezultate).

  // Numărul de produse distincte afișate ca rezultate (fără header, footer, coș, recomandări).
  function countSearchResults() {
    var EXCLUDE =
      'header,footer,nav,[role="banner"],[role="navigation"],' +
      '.cart,.cart-drawer,[id*="cart" i],[class*="cart" i],' +
      'predictive-search,[class*="predictive" i],' +
      '[class*="recommend" i],[class*="related" i]';
    var anchors = document.querySelectorAll('a[href*="/products/"]');
    var handles = {};
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.closest && a.closest(EXCLUDE)) continue;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) handles[m[1]] = 1;
    }
    return Object.keys(handles).length;
  }

  // Emite căutarea: numărul de rezultate din temă, din selectorul configurat sau numărat automat.
  function emitSearch(query, s) {
    var count = null;
    if (s.results_count != null) {
      count = Number(s.results_count);
    } else if (CFG.searchResultSelector) {
      try {
        count = document.querySelectorAll(CFG.searchResultSelector).length;
      } catch (e) {
        count = null;
      }
    }
    if (count == null) count = countSearchResults();
    if (!isFinite(count) || count < 0) return;

    var data = { query: String(query), results_count: Math.floor(count) };
    if (
      s.filters_active &&
      typeof s.filters_active === 'object' &&
      !Array.isArray(s.filters_active) &&
      Object.keys(s.filters_active).length
    ) {
      data.filters_active = s.filters_active;
    }
    putStr(data, 'category_inferred', s.category_inferred);
    cheiaVizitei = enqueue('search', data);
  }

  // Pe pagina de căutare, după ce s-au randat rezultatele.
  function captureSearch(page) {
    if (!page || page.page_type !== 'search') return;
    var s = page.search || {};
    var params = new URLSearchParams(location.search);
    var query = s.query || params.get('q') || params.get('query');
    if (!query || String(query).trim() === '') return;

    var run = function () {
      emitSearch(query, s);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }
  captureSearch(PAGE);
  // ╚══ sfârșit search ════════════════════════════════════════════════════════╝

  // ╔══ EVENIMENT: homepage_view ══════════════════════════════════════════════╗
  // Vizita primei pagini. N-are date proprii: de unde a venit și ce sesiune e stau în plic, iar timpul
  // și derularea se scriu pe el la plecare.
  function captureHomepageView() {
    if (PAGE_TYPE !== 'homepage') return;
    cheiaVizitei = enqueue('homepage_view', {});
  }
  captureHomepageView();
  // ╚══ sfârșit homepage_view ═════════════════════════════════════════════════╝

  // ╔══ MĂSURILE VIZITEI: timp activ și derulare ══════════════════════════════╗
  // Nu sunt evenimente: la plecarea din pagină se scriu pe rândul vizitei (homepage_view,
  // product_view, collection_view sau search) prin cheia lui. Fără rând de vizită nu se trimite nimic.
  function setupPageExit() {
    var EXIT_PAGES = { homepage: 1, pdp: 1, plp: 1, search: 1 };
    if (!PAGE_TYPE || !EXIT_PAGES[PAGE_TYPE]) return;

    var activeMs = 0;
    var lastResume = document.visibilityState !== 'hidden' ? Date.now() : null;
    var maxPct = 0;
    var ticking = false;
    var sent = false;

    function pct() {
      var doc = document.documentElement;
      var winH = window.innerHeight || doc.clientHeight;
      var docH = Math.max(
        document.body ? document.body.scrollHeight : 0,
        doc.scrollHeight,
        doc.offsetHeight,
        doc.clientHeight,
      );
      if (docH <= winH) return 100;
      var top = window.pageYOffset || doc.scrollTop || 0;
      return Math.max(0, Math.min(100, Math.round(((top + winH) / docH) * 100)));
    }
    function sample() {
      var p = pct();
      if (p > maxPct) maxPct = p;
    }
    function accumulate() {
      if (lastResume != null) {
        activeMs += Date.now() - lastResume;
        lastResume = null;
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          sample();
        });
      },
      { passive: true },
    );
    sample();

    function finalize() {
      if (sent || !cheiaVizitei) return;
      sent = true;
      accumulate();
      sample();
      var masuri = { scroll_pct: maxPct };
      if (activeMs > 0) masuri.dwell_ms = Math.round(activeMs);
      enqueueCompletion(cheiaVizitei, masuri);
      flush();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') finalize();
      else lastResume = Date.now();
    });
    window.addEventListener('pagehide', finalize);
  }
  setupPageExit();
  // ╚══ sfârșit măsurile vizitei ══════════════════════════════════════════════╝

  // ╔══ EVENIMENT: checkout_start ═════════════════════════════════════════════╗
  // Pornirea plății: coșul e ținut în cache (din /cart.js) și emis sincron la click pe checkout.
  function setupCheckoutStart() {
    var lastCart = null;
    var sent = false;
    var refreshTimer = null;

    // Reîmprospătează coșul din API-ul Shopify.
    function refreshCart() {
      try {
        fetch('/cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) {
            return r && r.ok ? r.json() : null;
          })
          .then(function (c) {
            if (c) lastCart = c;
          })
          .catch(function () {});
      } catch (e) {
        /* fără coș, fără eveniment */
      }
    }
    function scheduleRefresh(delay) {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshCart, delay || 0);
    }

    // Coșul Shopify → datele evenimentului (banii vin în bani, deci /100).
    function cartToData(c) {
      if (!c || c.item_count == null) return null;
      var total = Number(c.total_price);
      var data = {
        cart_total: isFinite(total) ? total / 100 : 0,
        item_count: Math.max(0, parseInt(c.item_count, 10) || 0),
      };
      if (Array.isArray(c.items) && c.items.length) {
        var items = [];
        for (var i = 0; i < c.items.length; i++) {
          var it = c.items[i];
          if (it.product_id == null || it.variant_id == null) continue;
          items.push({
            product_id: String(it.product_id),
            variant_id: String(it.variant_id),
            qty: Math.max(1, parseInt(it.quantity, 10) || 1),
            price: isFinite(Number(it.price)) ? Number(it.price) / 100 : 0,
          });
        }
        if (items.length) data.items = items;
      }
      return data;
    }

    // Emite o singură dată, din cache, fără să blocheze navigarea.
    function emitCheckout() {
      if (sent) return;
      var data = cartToData(lastCart);
      if (!data || data.item_count < 1) return;
      sent = true;
      enqueue('checkout_start', data);
      flush();
    }

    refreshCart();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') scheduleRefresh(0);
    });
    document.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (f && f.matches && f.matches('form[action*="/cart/add"]')) scheduleRefresh(600);
      },
      true,
    );

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[name="checkout"], a[href*="/checkout"], a[href*="/checkouts"]')) emitCheckout();
      },
      true,
    );
    document.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (!f || !f.matches) return;
        if (f.matches('form[action*="/checkout"]')) emitCheckout();
        else if (f.matches('form[action*="/cart"]') && f.querySelector('[name="checkout"]')) emitCheckout();
      },
      true,
    );
  }
  setupCheckoutStart();
  // ╚══ sfârșit checkout_start ════════════════════════════════════════════════╝

  // ╔══ ATRIBUIRE COMANDĂ ═════════════════════════════════════════════════════╗
  // Pune anon_id pe coș (atribut ascuns), ca webhook-ul de cumpărare să lege comanda de vizită.
  function setupCartAttribution() {
    var KEY = 'mxp_cart_tagged';
    function ensure() {
      try {
        if (sessionStorage.getItem(KEY) === anonId) return;
      } catch (e) {
        /* setăm oricum */
      }
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { _mxp_aid: anonId } }),
        })
          .then(function (r) {
            if (r && r.ok) {
              try {
                sessionStorage.setItem(KEY, anonId);
              } catch (e) {
                /* noop */
              }
            }
          })
          .catch(function () {});
      } catch (e) {
        /* fără atribuire */
      }
    }
    document.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (f && f.matches && f.matches('form[action*="/cart/add"]')) setTimeout(ensure, 700);
      },
      true,
    );
    if (/^\/(cart|checkout)/.test(location.pathname)) ensure();
  }
  setupCartAttribution();
  // ╚══ sfârșit atribuire comandă ═════════════════════════════════════════════╝

  // ╔══ EVENIMENT: wishlist ═══════════════════════════════════════════════════╗
  // Adăugare / scoatere din favorite (Wishlist King), pe orice pagină.
  function setupWishlist(page) {
    var SEL =
      'wishlist-button-product, wishlist-button-collection, wk-button, ' +
      'wk-icon[icon="wishlist"], [aria-label*="wishlist" i], [data-mxp-wishlist]';

    var handleIdCache = {};

    // product_id numeric din atributele unui element (acceptă și gid://…/Product/123).
    function pidFromAttrs(node) {
      if (!node || !node.getAttribute) return null;
      var keys = ['data-product-id', 'product-id', 'data-product', 'data-pid', 'product'];
      for (var i = 0; i < keys.length; i++) {
        var v = node.getAttribute(keys[i]);
        if (!v) continue;
        v = String(v).trim();
        var gid = v.match(/Product\/(\d+)/);
        if (gid) return gid[1];
        if (/^\d+$/.test(v)) return v;
      }
      return null;
    }

    // handle → product_id numeric, prin API-ul Shopify (cu cache).
    function fetchProductIdByHandle(handle) {
      if (handleIdCache[handle]) return Promise.resolve(handleIdCache[handle]);
      try {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          headers: { accept: 'application/json' },
          credentials: 'same-origin',
        })
          .then(function (r) {
            return r && r.ok ? r.json() : null;
          })
          .then(function (p) {
            if (p && p.id != null) {
              handleIdCache[handle] = String(p.id);
              return handleIdCache[handle];
            }
            return null;
          })
          .catch(function () {
            return null;
          });
      } catch (e) {
        return Promise.resolve(null);
      }
    }

    // product_id-ul butonului apăsat: atribut numeric → produsul paginii → handle rezolvat.
    function resolveProductId(el) {
      var holder = el.closest
        ? el.closest('[data-product-id],[product-id],[data-product],[data-pid]')
        : null;
      var id = pidFromAttrs(holder) || pidFromAttrs(el);
      if (id) return Promise.resolve(id);

      var hw = el.closest ? el.closest('[data-product-handle]') : null;
      var handle = hw ? hw.getAttribute('data-product-handle') : null;

      if (page && page.product && page.product.id != null) {
        var mainHandle = page.product.handle ? String(page.product.handle) : null;
        if (!handle || (mainHandle && mainHandle === handle)) return Promise.resolve(String(page.product.id));
      }
      if (handle) return fetchProductIdByHandle(handle);
      return Promise.resolve(null);
    }

    // Butonul efectiv (cel care poartă clasa de stare).
    function btnEl(el) {
      if (el.tagName === 'BUTTON') return el;
      return (el.closest && el.closest('button')) || (el.querySelector && el.querySelector('button')) || el;
    }

    // add sau remove: după starea butonului înainte de click, apoi după etichetă.
    function resolveAction(el) {
      var b = btnEl(el);
      var cls = b && b.className ? String(b.className) : '';
      if (b && b.getAttribute && b.getAttribute('aria-pressed') === 'true') return 'remove';
      if (/\b(wk-selected|is-active|is-selected|selected|active|added|in-wishlist)\b/.test(cls))
        return 'remove';
      var withLabel =
        el.getAttribute && el.getAttribute('aria-label')
          ? el
          : (el.closest && el.closest('[aria-label]')) ||
            (el.querySelector && el.querySelector('[aria-label]'));
      var aria = withLabel && withLabel.getAttribute ? withLabel.getAttribute('aria-label') || '' : '';
      var label = (aria + ' ' + (el.textContent || '')).toLowerCase();
      if (/elimin|remove|[șs]terge|scoate/.test(label)) return 'remove';
      return 'add';
    }

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest(SEL);
        if (!el) return;
        var action = resolveAction(el);
        resolveProductId(el).then(function (productId) {
          if (!productId || !seTrimitePentru(productId)) return;
          enqueue('wishlist', { product_id: productId, action: action });
        });
      },
      true,
    );
  }
  setupWishlist(PAGE);
  // ╚══ sfârșit wishlist ══════════════════════════════════════════════════════╝

  // ╔══ EVENIMENT: identify ═══════════════════════════════════════════════════╗
  // Client logat: leagă anon_id de contul lui (o dată per sesiune). Numărul clientului și semnătura lui
  // vin gata făcute din mxp-preload.liquid, de la Shopify; aici doar se trimit.
  function setupIdentify() {
    var client = CFG.client;
    if (!client || !client.id || !client.semnatura) return;
    var customerId = String(client.id);
    try {
      if (sessionStorage.getItem('mxp_identified') === customerId) return;
      sessionStorage.setItem('mxp_identified', customerId);
    } catch (e) {
      /* emitem oricum */
    }
    enqueue('identify', {
      source: 'login',
      customer_id: customerId,
      signed_at: client.semnatLa,
      signature: client.semnatura,
    });
  }
  setupIdentify();
  // ╚══ sfârșit identify ══════════════════════════════════════════════════════╝

  // ╔══ SURSA: bannerul din care vine produsul ════════════════════════════════╗
  // Ultimul banner apăsat în vizită (al nostru sau al site-ului) și pagina la care a dus. Un produs pus
  // în coș chiar din acea pagină, sau deschis direct din ea, e „din rezultatul bannerului”.
  var SURSA_CHEIE = 'mxp_banner_sursa';
  var SURSA_VALABILA_MS = 30 * 60 * 1000;

  function caleaLinkului(href) {
    try {
      var u = new URL(href, location.href);
      return u.origin === location.origin ? u.pathname : null;
    } catch (e) {
      return null;
    }
  }

  function tineMinteBannerul(fel, cheie, href) {
    var cale = typeof href === 'string' ? caleaLinkului(href) : null;
    if (!cale || !cheie) return;
    try {
      sessionStorage.setItem(SURSA_CHEIE, JSON.stringify({ f: fel, k: String(cheie).slice(0, 256), p: cale.slice(0, 512), t: Date.now() }));
    } catch (e) {
      /* fără memorie, adăugarea nu se leagă de banner */
    }
  }

  // Bannerul din care vine pagina de acum: aceeași pagină cu cea a bannerului sau deschisă direct din ea.
  function sursaBannerului() {
    var s;
    try {
      s = JSON.parse(sessionStorage.getItem(SURSA_CHEIE) || 'null');
    } catch (e) {
      return null;
    }
    if (!s || typeof s.p !== 'string' || !(Date.now() - s.t < SURSA_VALABILA_MS)) return null;
    var deUnde = document.referrer ? caleaLinkului(document.referrer) : null;
    return location.pathname === s.p || deUnde === s.p ? s : null;
  }

  // Clicurile pe bannerele noastre (și pe rezerve) se țin minte aici; ale site-ului, la măsurarea lor.
  document.addEventListener(
    'click',
    function (ev) {
      var t = ev.target;
      var el = t && typeof t.closest === 'function' ? t.closest('.mxp-banner[data-banner-id], [data-mxp-rezerva="1"]') : null;
      if (el === null) return;
      var a = el.tagName === 'A' ? el : el.querySelector('a[href]');
      tineMinteBannerul('mxp', el.getAttribute('data-banner-id'), a ? a.getAttribute('href') : null);
    },
    true,
  );
  // ╚══ sfârșit sursa ═════════════════════════════════════════════════════════╝

  // ╔══ EVENIMENT: add_to_cart ════════════════════════════════════════════════╗
  // Adăugare în coș, prinsă la trimiterea formularului de coș (sau pe butonul marcat).
  var ATC_PAGE_TYPES = { pdp: 1, plp: 1, search: 1, recommendations: 1 };

  // Cheie deterministă pe 5 secunde, ca dublu-clickul să fie deduplicat de server.
  function addToCartKey(productId, variantId, quantity) {
    var bucket = Math.floor(Date.now() / 5000);
    var key = 'atc_' + anonId + '_' + productId + '_' + variantId + '_q' + quantity + '_' + bucket;
    return key.length > 128 ? key.slice(0, 128) : key;
  }

  // Construiește și emite evenimentul din formular (sau din atributele butonului).
  function captureAddToCart(form, btn) {
    var idEl = form ? form.querySelector('[name="id"]') : null;
    var qtyEl = form ? form.querySelector('[name="quantity"]') : null;

    var variantId = (idEl && idEl.value) || (btn && btn.getAttribute('data-variant-id'));

    var holder = form && form.closest ? form.closest('[data-product-id]') : null;
    var productId =
      (holder && holder.getAttribute('data-product-id')) ||
      (PAGE && PAGE.product && PAGE.product.id != null ? String(PAGE.product.id) : null) ||
      (btn && btn.getAttribute('data-product-id'));

    if (!productId || !variantId) return;

    var qty = parseInt(qtyEl ? qtyEl.value : btn && btn.getAttribute('data-quantity'), 10);
    if (!isFinite(qty) || qty < 1) qty = 1;

    var data = {
      product_id: String(productId),
      variant_id: String(variantId),
      quantity: qty,
    };
    if (PAGE && PAGE.product && PAGE.product.price != null) {
      var price = Number(PAGE.product.price);
      if (isFinite(price) && price >= 0) data.price = price;
    }
    if (PAGE && ATC_PAGE_TYPES[PAGE.page_type]) data.from_page_type = PAGE.page_type;

    // Din rezultatul unui banner: pleacă și `banner_cart`, pentru orice produs, și cel neurmărit.
    var sursa = sursaBannerului();
    if (sursa) {
      var dinBanner = {
        banner_kind: sursa.f,
        banner_key: sursa.k,
        landing: sursa.p,
        product_id: data.product_id,
        variant_id: data.variant_id,
        quantity: qty,
      };
      if (data.price !== undefined) dinBanner.price = data.price;
      enqueue('banner_cart', dinBanner, ('bc_' + addToCartKey(productId, variantId, qty)).slice(0, 128));
    }

    if (!seTrimitePentru(productId)) return;
    enqueue('add_to_cart', data, addToCartKey(productId, variantId, qty));
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        captureAddToCart(form, null);
      }
    },
    true,
  );

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mxp-add-to-cart]') : null;
    if (!btn) return;
    var form = btn.closest ? btn.closest('form[action*="/cart/add"]') : null;
    if (form) return;
    captureAddToCart(null, btn);
  });
  // ╚══ sfârșit add_to_cart ═══════════════════════════════════════════════════╝

  // ╔══ EVENIMENT: variant_change ═════════════════════════════════════════════╗
  // Schimbarea variantei pe pagina de produs: scanăm formularele de coș la orice change/click.
  function setupVariantChange(page) {
    if (!page || page.page_type !== 'pdp') return;
    var defaultVariant = page.product && page.product.variant_id != null ? String(page.product.variant_id) : null;

    var lastVariant = new WeakMap();

    function variantId(form) {
      var el = form && form.querySelector ? form.querySelector('[name="id"]') : null;
      return el && el.value ? String(el.value) : null;
    }
    function productIdFor(form) {
      var holder = form && form.closest ? form.closest('[data-product-id]') : null;
      return (
        (holder && holder.getAttribute('data-product-id')) ||
        (page.product && page.product.id != null ? String(page.product.id) : null)
      );
    }
    // Reține varianta inițială a fiecărui formular.
    function seedAll() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        if (!lastVariant.has(forms[i])) lastVariant.set(forms[i], variantId(forms[i]) || defaultVariant || null);
      }
    }
    // Emite pentru fiecare formular a cărui variantă s-a schimbat.
    function scan() {
      var forms = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];
        var to = variantId(form);
        if (!to) continue;
        var from = lastVariant.has(form) ? lastVariant.get(form) : defaultVariant;
        if (from && from !== to) {
          var pid = productIdFor(form);
          if (pid && seTrimitePentru(pid)) {
            enqueue('variant_change', {
              product_id: pid,
              from_variant_id: from,
              to_variant_id: to,
            });
          }
        }
        lastVariant.set(form, to);
      }
    }
    function scheduleScan() {
      setTimeout(scan, 0);
      setTimeout(scan, 300);
      setTimeout(scan, 700);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', seedAll);
    else seedAll();

    document.addEventListener('change', scheduleScan, true);
    document.addEventListener('click', scheduleScan, true);
  }
  setupVariantChange(PAGE);
  // ╚══ sfârșit variant_change ════════════════════════════════════════════════╝

  // ╔══ EVENIMENTE: general_banner_view + general_banner_click ════════════════╗
  // Bannerele site-ului de același fel cu ale noastre (elementele cu `data-mxp-product-type`, completat
  // sau gol): afișarea, când bannerul ajunge pe ecran, și clicul, cu locul lui pe pagină și în grilă și
  // dacă deasupra au apărut bannerele noastre, ca aceeași poziție să se compare cu și fără ele. Doar pe
  // paginile din `mxp_pagini_bannere` (`reordonare` din mxp-preload), unde pot apărea bannerele noastre.
  // Pe o pagină, afișările pleacă grupate, câteva bannere într-un singur eveniment.
  (function urmaresteBannereleSiteului() {
    if (CFG.reordonare !== true) return;
    var ATRIBUT = 'data-mxp-product-type';
    var SELECTOR = '[' + ATRIBUT + ']';
    var ASTEPTARE_MAX_MS = 4000;
    var GRUPARE_MS = 3000;
    var MAX_PE_EVENIMENT = 30;

    function vizibil(el) {
      return el.getClientRects().length > 0;
    }

    // Bannerul camerei (`.mxp-camera`, urcat de mxp-homepage.js) ține locul bannerelor noastre.
    function cuBannereleNoastre() {
      if (document.querySelector('.mxp-camera') !== null) return true;
      var s = document.querySelector('.mxp-banners');
      return s !== null && !s.hasAttribute('hidden') && vizibil(s);
    }

    // Bannerele de rezervă sunt ale noastre și se măsoară ca ale noastre (`banner_view`, `banner_click`).
    function alSiteului(el) {
      return el.getAttribute('data-mxp-rezerva') !== '1';
    }

    // Locul pe pagină, numărând de sus toate bannerele de felul acesta, inclusiv pe ale noastre.
    function pozitiaPePagina(el) {
      var toate = document.querySelectorAll('.mxp-banners:not([hidden]) .mxp-banner, ' + SELECTOR);
      var loc = 0;
      for (var i = 0; i < toate.length; i++) {
        if (!vizibil(toate[i])) continue;
        loc += 1;
        if (toate[i] === el) return Math.min(100, loc);
      }
      return null;
    }

    // Locul în grila lui; bannerul urcat în secțiunea noastră are locul de acolo.
    function pozitiaInGrila(el) {
      var sus = Number(el.getAttribute('data-mxp-pozitie'));
      if (sus > 0) return Math.min(50, sus);
      var frati = el.parentNode ? el.parentNode.children : [];
      var loc = 0;
      for (var i = 0; i < frati.length; i++) {
        if (!frati[i].hasAttribute(ATRIBUT)) continue;
        loc += 1;
        if (frati[i] === el) return Math.min(50, loc);
      }
      return 1;
    }

    // Cine e bannerul: `id`-ul din temă, altfel adresa linkului lui.
    function cheia(el) {
      if (el.id) return el.id.slice(0, 256);
      var a = el.querySelector('a[href]');
      var href = a ? a.getAttribute('href') : '';
      return (href || 'fara-cheie').slice(0, 256);
    }

    function descriere(el) {
      var d = { key: cheia(el), moved: el.getAttribute('data-mxp-mutat') === '1', position: pozitiaInGrila(el) };
      var pePagina = pozitiaPePagina(el);
      if (pePagina !== null) d.page_position = pePagina;
      var tip = String(el.getAttribute(ATRIBUT) || '').trim();
      if (tip) d.product_type = tip.slice(0, 128);
      var t = el.querySelector('.main-title, h1, h2, h3');
      var titlu = t ? String(t.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (titlu) d.title = titlu.slice(0, 160);
      return d;
    }

    // Pe paginile cu secțiunea noastră, afișările pornesc după ce s-a hotărât dacă apar bannerele
    // noastre (semnalul vine din mxp-homepage.js), ca locurile să fie cele finale.
    function dupaBannereleNoastre(fn) {
      var pornit = false;
      function o() {
        if (pornit) return;
        pornit = true;
        fn();
      }
      var asteapta =
        CFG.personalizare === true && document.querySelector('.mxp-banners') !== null && window.MXP_BANNERE_GATA !== true;
      if (!asteapta) return o();
      document.addEventListener('mxp:bannere-gata', o);
      setTimeout(o, ASTEPTARE_MAX_MS);
    }

    function pornesteAfisarile() {
      if (typeof IntersectionObserver !== 'function') return;
      var elemente = document.querySelectorAll(SELECTOR);
      if (elemente.length === 0) return;
      var cuNoi = cuBannereleNoastre();
      var vazute = [];
      var timer = null;
      function trimiteVazute() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        while (vazute.length > 0) {
          enqueue('general_banner_view', { with_mxp: cuNoi, banners: vazute.splice(0, MAX_PE_EVENIMENT) });
        }
      }
      var obs = new IntersectionObserver(
        function (intrari) {
          for (var i = 0; i < intrari.length; i++) {
            if (!intrari[i].isIntersecting) continue;
            obs.unobserve(intrari[i].target);
            vazute.push(descriere(intrari[i].target));
          }
          if (vazute.length > 0 && !timer) timer = setTimeout(trimiteVazute, GRUPARE_MS);
        },
        { threshold: 0.5 },
      );
      for (var k = 0; k < elemente.length; k++) {
        if (alSiteului(elemente[k])) obs.observe(elemente[k]);
      }
      // La plecare pleacă și ce s-a văzut în ultimele secunde.
      function laPlecare() {
        if (vazute.length === 0) return;
        trimiteVazute();
        flush();
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') laPlecare();
      });
      window.addEventListener('pagehide', laPlecare);
    }

    dupaBannereleNoastre(pornesteAfisarile);

    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        var el = t && typeof t.closest === 'function' ? t.closest(SELECTOR) : null;
        if (el === null || el.parentNode === null || !alSiteului(el)) return;
        var date = descriere(el);
        date.with_mxp = cuBannereleNoastre();
        var a = t.closest('a') || el.querySelector('a[href]');
        var href = a ? a.getAttribute('href') : null;
        if (typeof href === 'string' && href.length <= 2048 && /^(https?:\/\/|\/)/.test(href)) date.link = href;
        tineMinteBannerul('site', date.key, href);
        enqueue('general_banner_click', date);
        flush();
      },
      true,
    );
  })();
  // ╚══ sfârșit general_banner_view + general_banner_click ════════════════════╝

  // ╔══ CUTIA DE AȘTEPTARE ════════════════════════════════════════════════════╗
  // Scriptul de bannere (mxp-homepage.js) rulează în flux, înaintea senzorului (încărcat cu
  // `defer`); ce n-a putut trimite atunci a lăsat în `window.MXP_PENDING`. Golim cutia abia
  // acum, la sfârșit, când contextul paginii e știut — așa evenimentele pleacă complete.
  (function golesteCutia() {
    var cutie = window.MXP_PENDING;
    if (cutie && typeof cutie.length === 'number') {
      for (var i = 0; i < cutie.length; i++) {
        var x = cutie[i];
        if (x && typeof x.type === 'string' && x.data) enqueue(x.type, x.data);
      }
    }
    window.MXP_PENDING = {
      push: function (x) {
        if (x && typeof x.type === 'string' && x.data) enqueue(x.type, x.data);
        return 1;
      },
    };
  })();
  // ╚══ sfârșit cutia de așteptare ════════════════════════════════════════════╝
})();
